export const TOKEN_KEY = 'token'
export const HASH_KEY = 'hash'
export const USER_LANG_KEY = 'userLang'
export const SESSION_ID = 'sessionId'
export const REF_LINK = 'reflink'
export const UPDATE_BANNER = 'updateBanner'
export const STATE_SLICES_SAVED_TO_COOKIES = ['user']
export const PREV_URL = 'prevUrl'
export const VISIBLE_FILTERS_TOOLTIP = 'visibleFiltersTooltip'
export const PAYMENT_SOURCE = 'paymentSource'
